// import CadastrosMain from '../views/CadastrosMain'
const CadastrosMain = () => import(/* webpackChunkName: "group-callcenter-cadastros" */ '../views/CadastrosMain')

import {
  permissionsCadastroFila,
  permissionsCadastroOperador,
  permissionsCadastroPausa,
} from '../../../utils/permissionsCallCenter'

import operadoresRoute from '../modules/operadores/_routes'
import pausasRoute from '../modules/pausas/_routes'
import filasRoute from '../modules/filas/_routes'
import departamentosRoute from '../modules/departamentos/_routes'


export default [
  {
    path: 'cadastro',
    meta: {
      requiresAuth: true,
      permissions: [...permissionsCadastroFila, ...permissionsCadastroOperador, ...permissionsCadastroPausa],
    },
    component: CadastrosMain,
    children: [...operadoresRoute, ...pausasRoute, ...filasRoute, ...departamentosRoute],
  },
]
